import { c as _c } from "react/compiler-runtime";
import { LOGO_URLS } from "../agents";
type AgentIconProps = {
  agentId: string;
  size: number;
};
export function AgentIcon(t0) {
  const $ = _c(9);
  const {
    agentId,
    size
  } = t0;
  if (agentId === "passage-money") {
    const t1 = size * 0.7;
    let t2;
    if ($[0] !== t1) {
      t2 = <span style={{
        fontSize: t1,
        lineHeight: 1
      }} role="img" aria-label="money bag">💰</span>;
      $[0] = t1;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    return t2;
  }
  const logoUrl = LOGO_URLS[agentId];
  if (logoUrl) {
    const t1 = size > 48 ? 16 : 12;
    let t2;
    if ($[2] !== t1) {
      t2 = {
        borderRadius: t1
      };
      $[2] = t1;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    let t3;
    if ($[4] !== agentId || $[5] !== logoUrl || $[6] !== size || $[7] !== t2) {
      t3 = <img src={logoUrl} alt={agentId} width={size} height={size} style={t2} />;
      $[4] = agentId;
      $[5] = logoUrl;
      $[6] = size;
      $[7] = t2;
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    return t3;
  }
  return null;
}